import { styled } from '@clickcease/cc-client-components-lib'

export const InstructionsContainer = styled('div', {
  width: '100%',
  display: 'flex',
})

export const InstructionsDescription = styled('div', {
  flex: 1,
  minWidth: '650px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '$4',
})

export const InstructionsImages = styled('div', {
  flex: 1.4,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})
